import { StorageService } from './storage.service';
import { HistorySearchService } from './history-search.service';
import { FavoriteSearchService } from './favorite-search.service';

const initServices = (
  storageService: StorageService,
  historySearchService: HistorySearchService,
  favoriteSearchService: FavoriteSearchService,
) => async () => {
    console.log('init service - started');
    await storageService.init();
    await historySearchService.init();
    await favoriteSearchService.init();
  };

export { initServices };
